import { getCompanies } from '~apis/user';

const getTargetCompany = async (userId: string, accessToken?: string) => {
  const companies = await getCompanies({ userId, accessToken });
  const companyItems = companies?.Data?.data?.items;
  const companyId = companyItems?.[companyItems.length - 1]?.companyId;
  return companyId;
};

export default getTargetCompany;
